module.exports = __webpack_public_path__ + "img/mi-bug-report.82b6bc4b.svg";